'use strict'

function target(el, binding) {
  const hashs = location.hash.split('#')
  const isTarget = hashs.includes(binding.value)
  const hasTarget = el.classList.contains('targetable')

  if (isTarget === true && hasTarget === false) {
    el.classList.add('targetable')
  }
  if (isTarget === false && hasTarget === true) {
    el.classList.remove('targetable')
  }
}

export default {
  install(vue) {
    vue.directive('targetable', {
      deep: true,
      bind(el, binding) {
        target(el, binding)
        const callback = () => target(el, binding)

        window.addEventListener('hashchange', callback)
        el._onHashChange = callback
      },
      unbind(el, binding) {
        const callback = el._onHashChange

        window.removeEventListener('hashchange', callback)
        delete el._onHashChange
      },
    })
  },
}
